import React, { useMemo, useRef, useCallback } from "react";
import {Box, TextField, Button, Typography } from "@mui/material"
import ReactQuill, { Quill } from "react-quill"
import "react-quill/dist/quill.snow.css"
import { baseURL } from "../../Config/config";

// -----------------------------
// CUSTOM QUILL FONT SIZES
// -----------------------------
const Size = Quill.import("attributors/style/size");

Size.whitelist = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "24px",
  "28px",
  "32px",
  "36px",
  "40px",
  "48px",
];

Quill.register(Size, true);

const modulesConfig = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],

    [
      {
        size: [
          "12px",
          "14px",
          "16px",
          "18px",
          "20px",
          "24px",
          "28px",
          "32px",
          "36px",
          "40px",
          "48px",
        ],
      },
    ],

    [{ color: [] }, { background: [] }],

    ["bold", "italic", "underline", "strike"],

    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],

    [{ list: "ordered" }, { list: "bullet" }],

    [{ indent: "-1" }, { indent: "+1" }],

    ["blockquote"],

    ["link", "image", "video"],

    ["clean"],
  ],
  
};
const formats = [
  "header",
  "size",
  "color",
  "background",
  "bold",
  "italic",
  "underline",
  "strike",
  "align",
  "list",
  "bullet",
  "indent",
  "blockquote",
  "link",
  "image",
  "video",
];


function NewsletterForm({
  newsletter,
  setNewsletter,
  onSubmit,
  editStatus = false,
  saving = false,
}) {
    const quillRef = useRef(null);

const imageHandler = useCallback(() => {
  const input = document.createElement("input");

  input.type = "file";
  input.accept = "image/png,image/jpeg,image/webp";

  input.onchange = async () => {
    const file = input.files?.[0];

    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      alert("Please select an image smaller than 5 MB.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      // Change this to your existing backend base URL.
      const API_BASE_URL =
        baseURL ||
        "http://127.0.0.1:5000";

      const response = await fetch(
        `${API_BASE_URL}/admin/newsletter/upload-image`,
        {
          method: "POST",
          body: formData,

          // Add the same authentication headers used
          // by your existing admin newsletter APIs.
        }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(
          result.message || "Image upload failed."
        );
      }

      const editor = quillRef.current?.getEditor();

      if (!editor) {
        throw new Error("Newsletter editor is unavailable.");
      }

      const range = editor.getSelection(true);
      const index = range ? range.index : editor.getLength();

      editor.insertEmbed(
        index,
        "image",
        result.url,
        "user"
      );

      editor.setSelection(index + 1, 0);

    } catch (error) {
      console.error("Newsletter image upload failed:", error);
      alert(error.message || "Unable to upload image.");
    }
  };

  input.click();
}, []);

const modules = useMemo(
  () => ({
    toolbar: {
      container: modulesConfig.toolbar,
      handlers: {
        image: imageHandler,
      },
    },
  }),
  [imageHandler]
);
    console.log("Newsletter HTML:", newsletter.content);
  return (
    
    <>
 <style>
{`
  .ql-toolbar {
    border-radius: 14px 14px 0 0 !important;
    border: 1px solid #dbe3ec !important;
    background: #f8fbff;
    padding: 12px !important;
  }

  .ql-container {
    min-height: 500px;
    border-radius: 0 0 14px 14px !important;
    border: 1px solid #dbe3ec !important;
    background: white;
    font-family: Arial, Helvetica, sans-serif;
  }

  .ql-editor {
    min-height: 500px;
    padding: 28px 32px !important;

    font-family: Arial, Helvetica, sans-serif;
    font-size: 17px;
    line-height: 1.65;
    color: #334155;
  }

  .ql-editor p {
    margin: 0 0 12px 0;
  }

  .ql-editor h1 {
    font-size: 36px;
    line-height: 1.2;
    margin: 30px 0 16px;
    color: #061d34;
    font-weight: 800;
  }

  .ql-editor h2 {
    font-size: 30px;
    line-height: 1.25;
    margin: 26px 0 14px;
    color: #061d34;
    font-weight: 800;
  }

  .ql-editor h3 {
    font-size: 24px;
    line-height: 1.3;
    margin: 22px 0 12px;
    color: #061d34;
    font-weight: 700;
  }

  .ql-editor ul,
  .ql-editor ol {
    margin: 12px 0;
    padding-left: 28px;
  }

  .ql-editor li {
    margin-bottom: 6px;
  }

  .ql-editor blockquote {
    border-left: 4px solid #0078c9;
    margin: 20px 0;
    padding: 12px 20px;
    background: #f8fbff;
    color: #475569;
  }

  .ql-editor img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    margin: 20px auto;
    display: block;
  }

  .ql-editor a {
    color: #0078c9;
    text-decoration: underline;
  }


  /* -------------------------------- */
  /* FONT SIZE DROPDOWN LABELS        */
  /* -------------------------------- */

  .ql-snow .ql-picker.ql-size {
    width: 85px;
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: attr(data-value);
  }

  .ql-snow .ql-picker.ql-size .ql-picker-label:not([data-value])::before {
    content: "Size";
  }
`}
</style>
 {/* TITLE */}
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: 700,
          color: "#1e293b",
          mb: 1,
        }}
      >
        {editStatus ? "Edit NewsLetter" : "Create New NewsLetter"}
      </Typography>
       {/* TITLE */}
              <TextField
                label="Newsletter Subject"
                value={newsletter.subject || ""}
                name="subject"
                fullWidth
                onChange={(e) =>
          setNewsletter((prev) => ({
            ...prev,
            subject: e.target.value,
          }))
        }
                variant="outlined"
                sx={{
                  // Label font size
          "& .MuiInputLabel-root": {
            fontSize: "14px",
          },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
                    borderColor: "#0078c9",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#0078c9",
                  },
                  "& .MuiInputBase-input": {
            fontSize: "16px",
          },
          "& .MuiInputLabel-root.MuiInputLabel-shrink": {
        fontSize: "16px",
        transform: "translate(14px, -9px) scale(1)",
        backgroundColor: "#fff",
        padding: "0 5px",
        marginBottom:"15px",
         color:"#000"
      },
                }}
              />
      
      <Box sx={{ mt: 5 }}>

    
        <ReactQuill
  ref={quillRef}
  value={newsletter.content || ""}
  onChange={(value) =>
    setNewsletter((prev) => ({
      ...prev,
      content: value,
    }))
  }
  modules={modules}
  formats={formats}
  theme="snow"
/>
      </Box>

     <Button
  variant="contained"
  onClick={onSubmit}
  disabled={saving || newsletter.status !== "draft"}
  sx={{
    background: "#0078c9",
    textTransform: "none",
    borderRadius: "10px",
    marginTop:"10px",
    width:"120px",
    height:"60px",
    fontSize:"14px"
  }}
>
  {saving
    ? "Saving..."
    : editStatus
      ? "Update Newsletter"
      : "Save Draft"}
</Button>
    </>
  );
}

export default NewsletterForm;